export const orientationOptions = [
  { label: 'None', value: undefined },
  { label: 'Direction4_PlacerYaw', value: 'Direction4_PlacerYaw' }, // chests, furnaces
  { label: 'Direction6_PlacerDirection', value: 'Direction6_PlacerDirection' }, // pistons, observers
  { label: 'Direction6_HitDirection', value: 'Direction6_HitDirection' }, // ???
  { label: 'Axis3_HitDirection', value: 'Axis3_HitDirection' }, // // logs, beams
  { label: 'Yaw8_PlacerYaw', value: 'Yaw8_PlacerYaw' }, // logs, beams
  { label: 'Yaw16_PlacerYaw', value: 'Yaw16_PlacerYaw' }, // logs, beams
]

/**
 * dirRemap
 *
 * 0 north
 * 1 east
 * 2 south
 * 3 west
 * 4 up
 * 5 down
 *
 * assets specify which directions are `opaque: [n,e,s,w,u,d]` and `solid: [n,e,s,w,u,d]`
 * so when we rotate the block we need to rotate these arrays too.
 *
 * the dirRemap variable is an array of indices into the original opaque/solid to get the boolean.
 */

const directionOffsets = {
  north: { rotation: [0, 0, 0], position: [0, 0, 0], dirRemap: [0, 1, 2, 3, 4, 5] },
  east: { rotation: [0, 270, 0], position: [0, 0, 0], dirRemap: [1, 2, 3, 0, 4, 5] },
  south: { rotation: [0, 180, 0], position: [0, 0, 0], dirRemap: [2, 3, 0, 1, 4, 5] },
  west: { rotation: [0, 90, 0], position: [0, 0, 0], dirRemap: [3, 0, 1, 2, 4, 5] },
  up: { rotation: [90, 0, 0], position: [0, 16, -16], dirRemap: [4, 1, 5, 3, 2, 0] },
  down: { rotation: [-90, 0, 0], position: [0, 16, 16], dirRemap: [5, 1, 4, 3, 0, 2] },
  x: { rotation: [0, 0, 90], position: [16, 16, 0], dirRemap: [0, 4, 2, 5, 3, 1] },
  y: { rotation: [0, 0, 0], position: [0, 0, 0], dirRemap: [0, 1, 2, 3, 4, 5] },
  z: { rotation: [90, 0, 0], position: [0, 16, -16], dirRemap: [4, 1, 5, 3, 2, 0] },
}

function yawToDirection4(yaw) {
  if (yaw >= 45 && yaw < 135) return 'east'
  if (yaw >= 135 && yaw < 225) return 'south'
  if (yaw >= 225 && yaw < 315) return 'west'
  return 'north'
}

function snapYawToSteps(yaw, steps) {
  const stepAngle = 360 / steps
  // normalize yaw to [0, 360)
  let normalized = yaw % 360
  if (normalized < 0) normalized += 360
  const snapped = Math.round(normalized / stepAngle) * stepAngle
  return snapped % 360
}

export class BehaviorOrientation {
  //
  static onBlockPlace(world, ctx, asset, blockState) {
    const type = asset.behaviors?.orientation
    if (type === 'Direction4_PlacerYaw') {
      blockState.props.facing = yawToDirection4(ctx.placer.yaw)
    } else if (type === 'Direction6_PlacerDirection') {
      blockState.props.facing = ctx.placer.direction.name
    } else if (type === 'Direction6_HitDirection') {
      blockState.props.facing = ctx.hit.direction.opposite.name
    } else if (type === 'Axis3_HitDirection') {
      blockState.props.axis = ctx.hit.direction.axis
    } else if (type === 'Axis3_PlacerDirection') {
      blockState.props.axis = ctx.placer.direction.axis
    } else if (type === 'Yaw8_PlacerYaw') {
      blockState.props.yaw = snapYawToSteps(ctx.placer.yaw, 8)
    } else if (type === 'Yaw16_PlacerYaw') {
      blockState.props.yaw = snapYawToSteps(ctx.placer.yaw, 16)
    }
    // console.log('blockState', blockState)
  }

  static onBlockBuild(asset, props) {
    // console.log('orientation.onBlockBuild')
    // console.log('props', props)
    if (props.facing) {
      const root = asset.model.root
      const offset = directionOffsets[props.facing]
      root.rotation[0] += offset.rotation[0]
      root.rotation[1] += offset.rotation[1]
      root.rotation[2] += offset.rotation[2]
      root.position[0] += offset.position[0]
      root.position[1] += offset.position[1]
      root.position[2] += offset.position[2]
      const opaque = offset.dirRemap.map(i => asset.opaque[i])
      asset.opaque = opaque
      const solid = offset.dirRemap.map(i => asset.solid[i])
      asset.solid = solid
    }
    if (props.axis) {
      const root = asset.model.root
      const offset = directionOffsets[props.axis]
      root.rotation[0] += offset.rotation[0]
      root.rotation[1] += offset.rotation[1]
      root.rotation[2] += offset.rotation[2]
      root.position[0] += offset.position[0]
      root.position[1] += offset.position[1]
      root.position[2] += offset.position[2]
      const opaque = offset.dirRemap.map(i => asset.opaque[i])
      asset.opaque = opaque
      const solid = offset.dirRemap.map(i => asset.solid[i])
      asset.solid = solid
    }
    if (props.yaw) {
      const root = asset.model.root
      root.rotation[1] = -props.yaw // yaw is clockwise, rotation is anti-cw
      // note: 8/16 point yaw leaves solid/opaque alone
    }
  }
}
